<template>
  <section class="auth-page">
    <b-container class="auth-container">
      <b-card class="auth-card">
        <h1 class="auth-title">Reset password</h1>
        <p class="auth-subtitle">Enter your email and we will send a reset link.</p>

        <b-alert v-if="errorMessage" show variant="danger" class="mb-3">
          {{ errorMessage }}
        </b-alert>
        <b-alert v-if="successMessage" show variant="success" class="mb-3">
          {{ successMessage }}
        </b-alert>

        <b-form @submit.prevent="handleReset">
          <b-form-group label="Email" label-for="forgot-email">
            <b-form-input
              id="forgot-email"
              v-model.trim="email"
              type="email"
              required
              autocomplete="email"
              placeholder="you@example.com"
            />
          </b-form-group>

          <b-button type="submit" variant="primary" class="w-100" :disabled="submitting">
            {{ submitting ? "Sending..." : "Send reset email" }}
          </b-button>
        </b-form>

        <div class="auth-links mt-3">
          <router-link :to="loginLink">Back to login</router-link>
        </div>
      </b-card>
    </b-container>
  </section>
</template>

<script>
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { sendResetPassword } from "@/services/authService";

export default {
  name: "ForgotPasswordView",
  setup() {
    const route = useRoute();
    const email = ref("");
    const submitting = ref(false);
    const errorMessage = ref("");
    const successMessage = ref("");

    const loginLink = computed(() => ({
      name: "Login",
      query: route.query.redirect ? { redirect: route.query.redirect } : {}
    }));

    const clearBodyScrollLock = () => {
      if (typeof document === "undefined") {
        return;
      }

      document.body.classList.remove("modal-open");
      document.body.style.removeProperty("overflow");
      document.body.style.removeProperty("padding-right");
    };

    onMounted(() => {
      clearBodyScrollLock();
    });

    const handleReset = async () => {
      submitting.value = true;
      errorMessage.value = "";
      successMessage.value = "";

      try {
        await sendResetPassword(email.value);
        successMessage.value =
          "If that email is registered, you will receive a password reset link shortly.";
      } catch (error) {
        errorMessage.value = error.message || "Unable to send reset email right now.";
      } finally {
        submitting.value = false;
      }
    };

    return {
      email,
      submitting,
      errorMessage,
      successMessage,
      loginLink,
      handleReset
    };
  }
};
</script>

<style scoped>
.auth-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  min-height: 100vh;
  width: 100%;
}

.auth-container {
  max-width: 520px;
}

.auth-card {
  border-radius: 14px;
  border: 1px solid #ececec;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  height: auto;
}

.auth-title {
  font-size: 30px;
  margin-bottom: 8px;
}

.auth-subtitle {
  color: #5b616e;
  margin-bottom: 16px;
}

.auth-links {
  font-size: 14px;
}
</style>
